import script from "./ResultPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultPage.vue?vue&type=script&setup=true&lang=js"

import "./ResultPage.vue?vue&type=style&index=0&id=e396847a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e396847a"]])

export default __exports__